import { createTheme } from '@mui/material/styles';
import { COLORS } from './Colors';

export const aimsTheme = createTheme({
  palette: {
    primary: {
      main: COLORS.teal,
      dark: COLORS.darkTeal,
    },
    error: {
      main: COLORS.red,
    },
    success: {
      main: COLORS.success,
    },
  },
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          WebkitTextSizeAdjust: '100%',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 6,
          minHeight: 40,
        },
      },
    },
  },
});
